import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { catchErrorTypedAsync } from '../../../../../services/functions-helper.service';
import { IAssetFromCollection, IAssetCollectionService, ISourceToImage } from './photo-list-model';

interface ITagForPrompt {
    text: string;
}

@Component({
    selector: 'app-photos-list',
    templateUrl: './photos-list.component.html',
    styleUrl: './photos-list.component.scss',
})
export class PhotosListComponent implements OnInit, OnDestroy {
    @HostListener('document:keydown.enter', ['$event'])
    onEnterClicked(event: KeyboardEvent): void {
        this.setNewPrompt(this.prompt);
    }

    @Input({ alias: 'photoService', required: true })
    photoService: IAssetCollectionService;
    @Input({ alias: 'itemsPerPage', required: true })
    itemsPerPage: number;
    @Input({ alias: 'isLoading', required: true })
    isLoading: boolean;

    @Input({ alias: 'initialPrompt', required: false }) initialPrompt?: string;

    @Output()
    newPhotoSelected = new EventEmitter<{ assetFromCollection: IAssetFromCollection; type: 'image' | 'video' }>();

    tagsForPrompt: ITagForPrompt[] = [];
    photos: IAssetFromCollection[] = [];
    currentPage: number = 1;
    prompt: string;
    totalPages: [] = [];
    source: ISourceToImage;
    selectedPhoto: IAssetFromCollection;
    errorMessage: string;

    currentType: 'image' | 'video';
    onDestroy$ = new Subject<boolean>();

    texts: {
        assetByText: string;
        noAssetsText: string;
        loadingAssetText: string;
        selectText: string;
    };

    constructor() {}

    ngOnInit() {
        this.source = this.photoService.source;

        this.currentType = this.photoService.type;
        switch (this.currentType) {
            case 'image': {
                this.texts = {
                    assetByText: 'Photo',
                    noAssetsText: 'No Images Found',
                    loadingAssetText: 'Loading Images...',
                    selectText: 'Select Image',
                };

                break;
            }
            case 'video': {
                this.texts = {
                    assetByText: 'Video',
                    noAssetsText: 'No Videos Found',
                    loadingAssetText: 'Loading Videos...',
                    selectText: 'Select Video',
                };

                break;
            }
        }
        this.initializeTagsForPrompt();
        if (this.initialPrompt) {
            this.setNewPrompt(this.initialPrompt);
        }
    }

    selectPhoto(photo: IAssetFromCollection) {
        this.selectedPhoto = photo;
        this.newPhotoSelected.emit({ assetFromCollection: photo, type: this.currentType });
    }

    setNewPrompt(prompt: string) {
        this.prompt = prompt;
        this.getPhotosAsync();
    }

    goToPage(pageNumber: number): void {
        if (pageNumber < 1) {
            return;
        }
        if (!this.totalPages && pageNumber > this.totalPages.length) {
            return;
        }
        this.currentPage = pageNumber;
        this.getPhotosAsync();
    }

    private async getPhotosAsync() {
        const { data: photoData, error } = await catchErrorTypedAsync(
            this.photoService.getAssetsAsync(this.prompt, this.itemsPerPage, this.currentPage)
        );
        if (!photoData || error) {
            this.errorMessage = 'Please try again';
            this.photos = [];
            return;
        }
        if (photoData.errorMessage) {
            this.errorMessage = photoData.errorMessage;
            this.photos = [];
            return;
        }
        const { photos, totalPages, totalItems } = photoData.payload;
        this.photos = photos;
        const numberOfPages = Math.min(totalPages, 10);
        this.totalPages = [].constructor(numberOfPages);
    }

    initializeTagsForPrompt() {
        this.tagsForPrompt = [
            {
                text: 'Businesses',
            },
            {
                text: 'Technology',
            },
            {
                text: 'People',
            },
        ];
    }
    onLoadedMetadata(video: HTMLVideoElement) {
        video.muted = true; // ensure mute is applied programmatically
        video.play().catch(() => {});
    }
    goToProfile(link: string) {
        window.open(link, '_blank');
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
